import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { Row, Col, Input, Pagination,Button } from 'antd'
import { axiosPost, enterprise } from '../../../utils/requestUtil'
import { getCookieValue, setCookieValue, removeCookieValue } from '../../../utils/cookieUtil'
import { checkUser } from '../../../utils/currentUser'

import styles from './userCollect.module.css'
import playArt from '../../../assets/images/art_play.png';
import noRecord from '../../../assets/images/pic_no_record.png';
import pleaseLogin from '../../../assets/images/user_center_pleaseLogin.png';

const { Search } = Input

export default class UserCollect extends Component {
    constructor() {
        super()
        this.state = {
            user: {},
            keyword: '',
            index: 0,
            size: 12,
            userCollects: [],
            userCollectsTotal: 0
        }
    }

    componentDidMount() {
        checkUser(res => {
            if (res.code === 0) {
                this.setState({
                    user: res.user
                })
                this.getCollect()
            }
        })
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return
        }
    }

    getCollect = () => {
        const { keyword, index, size } = this.state
        let token = getCookieValue('current-user').token
        const params = {
            enterprise: enterprise,
            keyword: keyword,
            index: index,
            size: size
        }
        axiosPost(19, token, params, 'ArtVip', (res) => {
            if (res.code === 0) {
                this.setState({
                    userCollects: res.data.list,
                    userCollectsTotal: res.data.total
                })
            } else {
                this.setState({
                    userCollects: [],
                    userCollectsTotal: 0
                })
            }
        })
    }

    searchVideo = (e) => {
        this.setState({
            keyword: e,
            index: 0
        }, () => this.getCollect())
    }

    pageChange = (e) => {
        this.setState({
            index: e - 1
        }, () => this.getCollect())
    }

    //生成结构函数
    eachCollect = (item) => {
        return <div>
            <Link target='_blank' to={{ pathname: `/home/videoplay/${item.id}` }}>
                <div className={styles.videoCoverBox}>
                    <img src={item.pictrue} alt='' />
                    <div className={styles.playIconBox}>
                        <img src={playArt} alt='' />
                    </div>
                </div>
            </Link>
            <div className={styles.videoDetail}>
                <Link target='_blank' to={{ pathname: `/home/videoplay/${item.id}` }}>
                    <h2>{item.name}</h2>
                </Link>
                <p>讲师：{item.teacherName}</p>
            </div>
        </div>
    }

    render() {
        const { user, userCollects, userCollectsTotal, size, index } = this.state
        return (
            <div>
                {user.type && user.type !== '-1' ? <div>
                    <div style={{ marginBottom: '20px' }}>
                        <Row wrap={false}>
                            <Col flex='none'>
                                <span className={styles.historyTitle}>我的收藏</span>
                            </Col>
                            <Col flex='auto'>
                                <Search style={{ width: '50%' }} placeholder='输入关键字搜索' onSearch={this.searchVideo} enterButton />
                            </Col>
                        </Row>
                    </div>
                    <div>
                        {userCollects.length > 0 ? <Row gutter={[30, 30]}>
                            {userCollects.map(item => <Col sm={12} md={8} lg={8} xl={8} xxl={6} key={item.id}>
                                {this.eachCollect(item)}
                            </Col>)}
                        </Row> : <div className={styles.noDataBox}>
                                {/* 暂无历史，赶快去学习视频吧 */}
                                <img src={noRecord} alt='' />
                            </div>}
                    </div>
                    <div className={styles.paginationBox}>
                        <Pagination
                            total={userCollectsTotal}
                            showTotal={total => `共 ${total} 条数据`}
                            current={index + 1}
                            pageSize={size}
                            onChange={this.pageChange}
                            showSizeChanger={false}
                            size='default'
                            hideOnSinglePage
                        />
                    </div>
                </div> :<div style={{textAlign:'center'}}>
                        <img src={pleaseLogin} alt='' style={{height:'150px'}} />
                        <p style={{color:'#ccc'}}>请登录后查看收藏</p>
                        <Button style={{width:'150px'}} type='primary' onClick={this.props.goLogin}>登录</Button>
                    </div>}
            </div>
        )
    }
}